/**
 * Copyright 2024-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { FlexContainer } from "@nordcloud/gnui";
import { NoData } from "../NoData";

export function ResourcesNoData() {
  return (
    <NoData
      hasIcon
      customCss={{ flexDirection: "column" }}
      message={
        <FlexContainer
          justifyContent="center"
          direction="column"
          css={{ textAlign: "center" }}
        >
          Please add resources to the action.
        </FlexContainer>
      }
    />
  );
}
